import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import enIN from "./Common/locales/en/translation.json";
import ta from "./Common/locales/ta/translation.json"; // Tamil translation

i18n
    .use(initReactI18next)
    .init({
        resources: {
            "en-IN": { translation: enIN },
            "ta": { translation: ta }
        },
        lng: localStorage.getItem("i18nextLng") || "en-IN", // Persist language
        fallbackLng: "en-IN",
        interpolation: { escapeValue: false },
    });

export default i18n;